import styles from './DialogBackdrop.module.scss'
import React from 'react'
import clsx from 'clsx'

interface DialogBackdropProps {
    className?: string
}

export function DialogBackdrop({
    className,
}: DialogBackdropProps) {
    return (
        <div className={clsx(styles.backdrop, className)}></div>
    )
}
